import React from "react";
import styled from "styled-components";
import { Row, Col } from "react-bootstrap";
import Markdown from "src/components/Markdown";
import SubTitleSection from "src/components/SubTitleSection/SubTitleSection";

/**
 * Event list component that displays events in a two-column layout
 * with title/description on the left and guarantee pill on the right
 */
const TournamentEventList = ({ events = [] }) => {
  if (!Array.isArray(events) || events.length === 0) return null;

  // Helper function to split title into buy-in and event name
  const parseTitleWithBuyIn = (title) => {
    const match = title.match(/^(\$[\d,]+)\s+(.+)$/);
    if (match) {
      return { buyIn: match[1], eventName: match[2] };
    }
    return { buyIn: null, eventName: title };
  };

  return (
    <EventListWrapper>
      {events.map((event, index) => {
        const { buyIn, eventName } = parseTitleWithBuyIn(event.title);
        
        return (
          <Row key={`event-${index}`} className="mb-2 g-0">
            <Col md={7}>
              {buyIn ? (
                <EventTitle>
                  <h4>
                    <span className="buy-in">{buyIn}</span>
                    <span className="event-name">{eventName}</span>
                  </h4>
                  {event.description && <p>{event.description}</p>}
                </EventTitle>
              ) : (
                <SubTitleSection
                  subTitle={event.title}
                  text={event.description}
                  as="h4"
                  dark={true}
                  variant="compact"
                  subtitleColor="var(--red)"
                  className="py-0"
                />
              )}
            </Col>
            {event.guarantee && (
              <Col md={5}>
                <EventGuarantee>
                  <Markdown>{event.guarantee}</Markdown>
                </EventGuarantee>
              </Col>
            )}
          </Row>
        );
      })}
    </EventListWrapper>
  );
};

const EventListWrapper = styled.div`
  @media (max-width: 768px) {
    .mb-3 {
      margin-bottom: 1.5rem !important;
    }
  }
`;

const EventTitle = styled.div`
  h4 {
    font-weight: 700;
    margin: 0;
    line-height: 1.2;
  }

  .buy-in {
    display: block;
    color: var(--red);
    font-size: 1.5rem;
    margin-bottom: 0;
  }

  .event-name {
    display: block;
    color: #fff;
    font-size: 1.15rem;
  }

  p {
    margin: 0;
    color: var(--lightgrey);
    font-size: 0.95rem;
  }

  @media (max-width: 768px) {
    .buy-in {
      font-size: 1.3rem;
    }

    .event-name {
      font-size: 1rem;
    }
  }
`;

const EventGuarantee = styled.div`
  margin-top: 5px;
  display: flex;
  align-items: center;
  height: 100%;

  p {
    margin: 0 !important;
    display: block;
    width: 100%;
    background: var(--red);
    color: #fff;
    font-size: 0.95rem;
    font-weight: 700;
    line-height: 1.3;
    padding: 0.6rem 1rem;
    border-radius: 6px;
    letter-spacing: 0.01em;
    text-align: center;
    white-space: nowrap;

    strong {
      font-weight: 700;
    }
  }

  @media (max-width: 768px) {
    margin-top: 0.75rem;
    margin-bottom: 0;
    
    p {
      width: auto;
      display: inline-block;
      min-width: 14rem;
      font-size: 0.9rem;
      padding: 0.5rem 0.875rem;
    }
  }
`;

export default TournamentEventList;
